import { lt } from 'semver'
import { UAParser } from 'ua-parser-js'

const MIN_CHROME_VERSION = '110.0.0'
const MIN_FIREFOX_VERSION = '102.0.0'
const MIN_MOBILE_SAFARI_VERSION = '15.6.0'
const MIN_SAFARI_VERSION = '15.6.0'

const MIN_IOS_VERSION = '15.6.0'
const MIN_MACOS_VERSION = '10.15.0' // Catalina

const ENGINE_MIN_VERSIONS: Record<string, string> = {
  Blink: MIN_CHROME_VERSION,
  Gecko: MIN_FIREFOX_VERSION,
  WebKit: '537.36.0',
}

const convertToSemver = (version: string) => {
  const segments = version.split('.')
  while (segments.length < 3) {
    segments.push('0')
  }
  return segments.slice(0, 3).join('.')
}

export const isLegacyBrowser = (ua: string) => {
  try {
    const parser = new UAParser(ua)
    const { browser, engine, os } = parser.getResult()

    // OS Check for Apple devices
    if ((os.name === 'iOS' || os.name === 'macOS') && os.version) {
      const osVersion = os.name === 'iOS' ? MIN_IOS_VERSION : MIN_MACOS_VERSION
      return lt(convertToSemver(os.version), osVersion)
    }

    // Browser specific check
    switch (browser.name) {
      case 'Chrome':
      case 'Mobile Chrome':
        if (browser.version) {
          const isLegacy = lt(
            convertToSemver(browser.version),
            MIN_CHROME_VERSION,
          )
          return isLegacy
        }
        break
      case 'Firefox':
        if (browser.version)
          return lt(convertToSemver(browser.version), MIN_FIREFOX_VERSION)
        break
      case 'Mobile Safari':
        if (browser.version)
          return lt(convertToSemver(browser.version), MIN_MOBILE_SAFARI_VERSION)
        break
      case 'Safari':
        if (browser.version)
          return lt(convertToSemver(browser.version), MIN_SAFARI_VERSION)
        break
    }

    // Engine-based fallback
    if (engine?.name && browser?.version) {
      const minVersion = ENGINE_MIN_VERSIONS[engine.name]
      if (minVersion) {
        return lt(convertToSemver(browser.version), minVersion)
      }
    }

    // iOS Native App
    const isNativeApp = (ua.match(/Lottocom_app/) || [])[0]
    if (isNativeApp) {
      const iOSVersion = (ua.match(/iOS;\s*([\d.]+)/) || [])[1]

      if (iOSVersion) {
        return lt(convertToSemver(iOSVersion), MIN_IOS_VERSION)
      }
    }
  } catch (e) {
    console.error(e)
  }

  return false
}
